import React, { useEffect, useState } from "react";
import { H2, Text } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Slide1 from "../../assets/meta-preview-slide-1.png";
import Slide2 from "../../assets/meta-preview-slide-2.png";
import Slide3 from "../../assets/meta-preview-slide-3.png";
import Slide4 from "../../assets/meta-preview-slide-4.png";
import Slide5 from "../../assets/meta-preview-slide-5.png";
import { WIZARD_STEP_PATH } from "../../constants/paths";
import MetaWizardFooter from "../../elements/MetaWizard/MetaWizardFooter";
import MetaWizardHeader from "../../elements/MetaWizard/MetaWizardHeader";
import WizardHeader from "../../elements/WizardHeader";
import { AdSystemT, WizardStepT, useLeaveWizardMutation } from "../../graphql/generated/graphql";
import { useWizardState } from "../../hooks/useWizardState";
import { useSetWizardStepEffect } from "./useSetWizardStepEffect";

const slides = [Slide1, Slide2, Slide3, Slide4, Slide5];

export const MetaPreview = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Meta Preview" });
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const { googleWizardFinished } = useWizardState();
  const [leaveWizard] = useLeaveWizardMutation();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const backButtonHandler = async () => {
    await leaveWizard({ variables: { adSystem: AdSystemT.MetaAdsT } }).catch(() => undefined);
    navigate("/wizard/new-campaign-selection");
  };

  const nextButtonHandler = () => {
    navigate(WIZARD_STEP_PATH.META_PAGE_LINKING);
  };

  useSetWizardStepEffect({ adSystem: AdSystemT.MetaAdsT, wizardStep: WizardStepT.MetaFirstT });
  return (
    <div>
      <WizardHeader />
      <MetaWizardHeader activeStep={1} />
      <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
        <div className="meta-preview-block-1">
          <div style={{ marginBottom: "16px" }}>
            <H2 divider={false}>{t("Description title")}</H2>
          </div>
          <div>
            <Text>{t("Description paragraph 1")}</Text>
          </div>
          <div>
            <Trans components={{ b: <b /> }} i18nKey="Description paragraph 2" t={t} />
          </div>
          <ul style={{ margin: "16px 0", paddingLeft: "16px" }}>
            <li>
              <Trans components={{ b: <b /> }} i18nKey="Description item 1" t={t} />
            </li>
            <li>
              <Trans components={{ b: <b /> }} i18nKey="Description item 2" t={t} />
            </li>
            <li>
              <Trans components={{ b: <b /> }} i18nKey="Description item 3" t={t} />
            </li>
            <li>
              <Trans components={{ b: <b /> }} i18nKey="Description item 4" t={t} />
            </li>
            <li>
              <Trans components={{ b: <b /> }} i18nKey="Description item 5" t={t} />
            </li>
          </ul>
          <Text>{t("Description paragraph 3")}</Text>
        </div>
        <div className="meta-preview-block-2">
          <div style={{ marginBottom: "8px" }}>
            <Text appearance="strong-lg">{t("Info block title")}</Text>
          </div>
          <Text>
            <div>
              <Trans components={{ b: <b /> }} i18nKey="Info block text 1" t={t} />
            </div>
            <div>
              <Trans components={{ a: <a /> }} i18nKey="Info block text 2" t={t} />
            </div>
          </Text>
          <div style={{ position: "relative", width: "100%" }}>
            {slides.map((slide, index) => (
              <img
                key={index}
                alt=""
                src={slide}
                style={{
                  position: index === 0 ? "relative" : "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "auto",
                  opacity: currentSlide === index ? 1 : 0,
                  transition: "opacity 1s ease-in-out",
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <MetaWizardFooter
        backButtonHandler={backButtonHandler}
        nextButtonHandler={nextButtonHandler}
        showBackButton={!googleWizardFinished}
      />
    </div>
  );
};
